const initialState ={
  data:{},
  refresh:0
}

const reducer = (state = initialState, action) => {
  let newState=state;
  switch(action.type){
      case 'REQUEST_FOLDER_INDEX_SUCCESS':
        for(let f of action.val.folders){
          if(newState.data[f.type]==undefined){newState.data[f.type]={}}
          newState.data[f.type][f.id]=f;
          newState.data[f.type][f.id].items_length=0;
        }
        console.log('FOLDERR', action.val);
        if(action.val.items!=undefined){
          for(let i of action.val.items){
          newState=folderItemCount(newState, i.folder_id, action.val.folder_type);
        }}
        newState.refresh+=1;
        break;
      case 'REQUEST_FOLDER_ITEM_UPDATE_SUCCESS':
        if(newState.data[action.val.folder_type]==undefined){newState.data[action.val.folder_type]={}}
        if(action.val.old_folder_id!=action.val.new_folder_id){
          newState=removeOneFromFolder(newState, action.val.old_folder_id, action.val.folder_type);
          newState=addOneToFolder(newState, action.val.new_folder_id, action.val.folder_type);
        }
        newState.refresh+=1;
        break;
      case 'REQUEST_FOLDER_CREATE_SUCCESS':
      case 'REQUEST_FOLDER_UPDATE_SUCCESS':
      case 'REQUEST_FOLDER_GET_SUCCESS':
        if(newState.data[action.val.type]==undefined){newState.data[action.val.type]={}}
        if(newState.data[action.val.type][action.val.id]!=undefined && newState.data[action.val.type][action.val.id].folder_id!=action.val.folder_id){
          newState=removeOneFromFolder(newState, newState.data[action.val.type][action.val.id].folder_id, action.val.type, newState.data[action.val.type][action.val.id].items_length);
          newState=addOneToFolder(newState, action.val.folder_id, action.val.type, newState.data[action.val.type][action.val.id].items_length);
        }
        if(newState.data[action.val.type][action.val.id]==undefined){newState.data[action.val.type][action.val.id]={items_length:0};}
        newState.data[action.val.type][action.val.id]={...newState.data[action.val.type][action.val.id], ...action.val};
        newState.refresh+=1;
        break;
    }
    console.log('folders', newState);
  return newState;
}

function addOneToFolder(newState, folder_id, folder_type, n=1){
  if(folder_id!=undefined && newState.data[folder_type][folder_id]!=undefined){
    if(newState.data[folder_type][folder_id].items_length==undefined){newState.data[folder_type][folder_id].items_length=0;}
    newState.data[folder_type][folder_id].items_length+=n;
    return addOneToFolder(newState, newState.data[folder_type][folder_id].folder_id, folder_type);
  }else{return newState;}
}



function removeOneFromFolder(newState, folder_id, folder_type, n=1){
  if(folder_id!=undefined && newState.data[folder_type][folder_id]!=undefined){
    if(newState.data[folder_type][folder_id].items_length==undefined){newState.data[folder_type][folder_id].items_length=0;}
    newState.data[folder_type][folder_id].items_length-=n;
    console.log(folder_id, n, newState.data[folder_type][folder_id].items_length, 'ITEMS LENGTH');
    return removeOneFromFolder(newState, newState.data[folder_type][folder_id].folder_id, folder_type);
  }else{return newState;}
}

function folderItemCount(newState, folder_id, folder_type){
    if(folder_id!=undefined && newState.data[folder_type][folder_id]!=undefined){
      newState.data[folder_type][folder_id].items_length+=1;
      return folderItemCount(newState, newState.data[folder_type][folder_id].folder_id, folder_type);
    }else{return newState;}
}


export default reducer;
